import React, { FC, ReactNode, useState } from 'react';
import { SettingsContext } from './context';
import { RequestType } from 'models/item-request.model';
import { ActiveType } from 'models/vendors.model';
import { RoleType } from 'models/role.model';

export interface CreateUserType {
  phone_number: string;
  first_name: string;
  last_name: string;
  email: string;
  role: { id: string; name: string };
}
const SettingsProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [usersToEdit, setUsersToEdit] = useState<RequestType | any>(null);
  const [active, setActive] = useState<ActiveType | null>(null);
  const [userFormData, setUserFormData] = useState<CreateUserType[]>([]);
  const [step, setStep] = useState(1);
  const [roles, setRoles] = useState<RoleType[]>([]);

  return (
    <SettingsContext.Provider
      value={{
        usersToEdit,
        setUsersToEdit,
        active,
        setActive,
        step,
        setStep,
        userFormData,
        setUserFormData,
        roles,
        setRoles
      }}>
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsProvider;
